<script setup>
import { useWebSiteStore } from '@/stores/web-site.store'
import { useTimelineFocus } from '@/composables/project-timeline'
import ProjectTimeline from '@/components/planner/project-timeline/ProjectTimeline.vue'
import TopBarToggle from '@/components/shared/TopBarToggle.vue'

const webSiteStore = useWebSiteStore()
const focus = useTimelineFocus()
</script>

<template>
  <div :class="['timeline-gantt-mobile', { 'timeline-gantt-mobile--full': webSiteStore.topBarHidden }]">
    <project-timeline :initial-date="focus?.date" :focus="focus">
      <template #toolbar-end>
        <top-bar-toggle round size="sm" color="grey-7" />
      </template>
    </project-timeline>
  </div>
</template>

<style scoped>
.timeline-gantt-mobile {
  display: flex;
  height: calc(100dvh - 4rem);
}

.timeline-gantt-mobile--full {
  height: 100dvh;
}
</style>
